import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "social-icon-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22",
  height: "23",
  class: "ss-icon"
}, [
  /*#__PURE__*/_createVNode("rect", {
    "stroke-width": "0",
    x: "0",
    y: "0",
    width: "21",
    height: "21",
    rx: "3",
    ry: "3",
    class: "ss-color"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    class: "ss-inner-icon",
    "stroke-width": "0",
    d: "M7.62,6.13c-.64,0-1.13.48-1.15,1.1,0,.65.47,1.16,1.09,1.17.62,0,1.13-.49,1.13-1.13s-.48-1.14-1.08-1.16h0ZM11.56,15.38h-1.84v-6.11h1.76v.81s.11-.13.16-.19c.1-.12.18-.2.27-.29.77-.74,2.11-.56,2.68-.19.54.35.78.9.85,1.52.11.91.1,1.82.09,2.73,0,.58-.01,1.14,0,1.72h-1.83s-.06-.14-.04-.22v-2.8c0-.25,0-.48-.04-.72-.1-.56-.37-.84-.85-.87-.6-.03-.96.22-1.12.77-.1.33-.1.66-.1,1.01v2.83h.03ZM6.64,9.27h1.89v6.11h-1.89v-6.11Z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22",
  height: "23",
  class: "ss-icon"
}, [
  /*#__PURE__*/_createVNode("rect", {
    "stroke-width": "0",
    x: "0",
    y: "0",
    width: "21",
    height: "21",
    rx: "3",
    ry: "3",
    class: "ss-color"
  }),
  /*#__PURE__*/_createVNode("path", {
    "stroke-width": "0.8px",
    class: "cls-1 ss-inner-icon",
    d: "M9.03,7.34h-2.28l5.93,7.45h2.28l-5.93-7.45Z"
  }),
  /*#__PURE__*/_createVNode("path", {
    class: "ss-inner-icon",
    "stroke-width": "0",
    d: "M14.96,6.9h-1.65l-6.97,8.2h1.65s6.97-8.2,6.97-8.2Z"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22",
  height: "23",
  class: "ss-icon"
}, [
  /*#__PURE__*/_createVNode("rect", {
    "stroke-width": "0",
    x: "0",
    y: "0",
    width: "21",
    height: "21",
    rx: "3",
    ry: "3",
    class: "ss-color"
  }),
  /*#__PURE__*/_createVNode("path", {
    class: "ss-inner-icon",
    "stroke-width": "0",
    d: "M11.83,15.92v-4.42h1.61c.08-.6.17-1.19.26-1.8h-1.83s-.03-.06-.03-.08v-1.14c0-.35.19-.58.53-.66.07-.01.14-.01.21-.01h1.02s.08,0,.12-.01v-1.61s-.01,0,0,0c-.61,0-1.23-.01-1.84.01-.97.06-1.73.66-1.95,1.54-.04.17-.06.35-.06.53v1.44h-1.61v1.8h1.61v4.42h1.97-.01Z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.share_buttons && _ctx.share_buttons.linkedin)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          style: {"display":"inline-block !important"},
          class: "aw-ssi",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.share('linkedin')))
        }, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    (_ctx.share_buttons && _ctx.share_buttons.twitter)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          style: {"display":"inline-block !important"},
          class: "aw-ssi",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.share('twitter')))
        }, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.share_buttons && _ctx.share_buttons.facebook)
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          style: {"display":"inline-block !important"},
          class: "aw-ssi",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.share('facebook')))
        }, [
          _hoisted_4
        ]))
      : _createCommentVNode("", true)
  ]))
}